import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import SvgIcon from '@mui/material/SvgIcon'
import Typography from '@mui/material/Typography'
import { Bell } from '@styled-icons/heroicons-outline'
import React from 'react'

const ICON_CIRCLE_SIZE = 56

type NotificationEmptyStateProps = {
  title: string
  description: string
}

/**
 * Nothing to show, said in whatever way fits the surface — the bell's caught-up state and the page's
 * per-view and filtered ones. The bell is the header's own icon, muted, so an empty list still reads as
 * this feature rather than as a failure to load.
 */
const NotificationEmptyState = ({ title, description }: NotificationEmptyStateProps) => (
  <Stack alignItems="center" justifyContent="center" spacing={1.5} sx={{ height: '100%', px: 3, py: 5, textAlign: 'center' }}>
    <Box
      sx={{
        width: ICON_CIRCLE_SIZE,
        height: ICON_CIRCLE_SIZE,
        borderRadius: '50%',
        bgcolor: 'action.hover',
        color: 'text.disabled',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <SvgIcon fontSize="large">
        <Bell />
      </SvgIcon>
    </Box>
    <Stack spacing={0.5}>
      <Typography fontWeight={600} variant="h6">
        {title}
      </Typography>
      <Typography color="text.lightBrown" variant="body1">
        {description}
      </Typography>
    </Stack>
  </Stack>
)

export default NotificationEmptyState
